<script setup lang="ts">
import ContainerDialog from '@/components/rc/containers/ContainerDialog.vue'
import ContainersTable from '@/components/rc/tables/ContainersTable.vue'
import type { IContainerDashboard } from '@/types/rc/containers'
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import { ref } from 'vue'

const containerDialogOpen = ref<boolean>(false)
const containerBeingUpdated = ref<IContainerDashboard | undefined>(undefined)

const onAddContainer = () => {
  containerDialogOpen.value = true
  containerBeingUpdated.value = undefined
}

const onEditContainer = (container: IContainerDashboard) => {
  containerDialogOpen.value = true
  containerBeingUpdated.value = container
}
</script>

<template>
  <ViewLayout class="containers">
    <containers-table @edit="onEditContainer" />
    <template #controls>
      <el-button type="primary" @click="onAddContainer">Add container</el-button>
    </template>
    <ContainerDialog
      v-if="containerDialogOpen"
      v-model="containerDialogOpen"
      :container-id="containerBeingUpdated?.id"
    />
  </ViewLayout>
</template>
